<div style="display: flex; height: 100%;">
  <div class="left-column">
    <!--TODO: CHANGE ID TO TRAIN-CASE-->
    <button mat-mini-fab color="primary" class="add-job-button" id="addNewProductionButton"  (click)="createJob()" [disabled]="!userConfigService.inRoles(Role.EditFeatureSet, Role.Administrator)" matTooltip="Create new production"><mat-icon>add</mat-icon></button>
    <div class="card-container">
      <div *ngFor="let job of productionJobs">
        <div style="display: flex; flex-direction: row;">
          <div *ngIf="isSelectedJob(job)" style="padding-bottom: 21px">
            <div class="selected-job mat-elevation-z6"></div>
          </div>
          <mat-card appearance="outlined" id="selectProduction.{{job?.productionJobId}}" (click)="isSelectedJob(job) ? $event.stopImmediatePropagation() : selectedJob$.next(job)" style="width: 100%; margin: 10px 10px 10px 20px;" class="card-list" [ngClass]="{'selected': isSelectedJob(job)}">
            <mat-card-title style="place-content: center space-between; align-items: center; flex-direction: row; box-sizing: border-box; display: flex; font-size: 16px">
              <div *ngIf="editJobId === job.productionJobId;else job_title" style="width: 100%;">
                <mat-form-field style="flex: auto; width: 100%;">
                  <input matInput (blur)="patchJobTitle(job)" (keyup.enter)="patchJobTitle(job)" [(ngModel)]="job.title">
                </mat-form-field>
              </div>
              <ng-template #job_title>
                {{job.title}}
              </ng-template>
              <div>
                <button *inRole="[roles.Administrator, roles.Operations, roles.EditFeatureSet]" mat-icon-button [matMenuTriggerFor]="menu"><mat-icon>more_vert</mat-icon></button>
                <mat-menu #menu="matMenu">
                  <button *inRole="[roles.Administrator, roles.Developer, roles.Operations]" mat-menu-item id="force-create-zip.{{job?.productionJobId}}" (click)="forceCreateZip(job?.productionJobId)">Force create zip</button>
                  <button mat-menu-item id="renameProduction.{{job?.productionJobId}}" (click)="editJobId = job.productionJobId">Rename</button>
                  <button mat-menu-item id="deleteProduction.{{job?.productionJobId}}" [disabled]="(job.status === productionJobRunStatus.Queued || job.status === productionJobRunStatus.Running) && canUserDelete(job)" (click)="deleteJob(job)">Delete</button>
                </mat-menu>
              </div>
            </mat-card-title>
            <mat-card-subtitle style="flex-direction: column">
              <div *ngIf="job.status === productionJobRunStatus.PostRun">{{ job.batesRangeProduction }}</div>
              <div *ngIf="job.status === productionJobRunStatus.PostRun">{{ job.batesRangeWithheld }}</div>
              <div>{{ ( isJobProcessingOrDone(job) && !job.isImportProductionJob ? job.dateTimeRun : job.dateTimeCreated ) | date:'M/d/yyyy h:mm:ss a' }}</div>
              <div>{{ isJobProcessingOrDone(job) && !job.isImportProductionJob ? getUserName(job.runById) : getUserName(job.createdById) }}</div>
            </mat-card-subtitle>
            <mat-card-content>
              <div style="box-sizing: border-box; display: flex; place-content: center space-evenly; align-items: center;">
                <h3>{{job.totalDocCount ? job.totalDocCount?.toLocaleString() : 0 | number}} Docs</h3>
                <div *ngIf="job.status === productionJobRunStatus.NeedValidation">
                  <!--Disable button if there are no docs-->
                  <button mat-button color="primary"
                          id="validateProduction.{{job?.productionJobId}}"
                          [disabled]="(job.totalDocCount ? job.totalDocCount === 0 : true) || !this.selectedJob || (job.productionJobId !== this.selectedJob.productionJobId) || !userConfigService.inRoles(Role.EditFeatureSet, Role.Administrator)"
                          (click)="validateProduction= !validateProduction">
                    Validate
                  </button>
                </div>
                <div *ngIf="job.status === productionJobRunStatus.PreRun">
                  <!--Disable button if there are there is processing on going in the case-->
                  <button mat-button color="primary" id="runProduction.{{job?.productionJobId}}" [disabled]="!isJobFormValid(job)" (click)="addProductionToQueue(job)">Run</button>
                </div>
                <div *ngIf="job.status === productionJobRunStatus.Queued || job.status === productionJobRunStatus.Running">
                  Processing...
                </div>
                <div *ngIf="job.status === productionJobRunStatus.PostRun">
                  <button id="downloadProduction.{{job?.productionJobId}}"  mat-button color="primary" (click)="openDownloadProductionPartDialog(job)">Download</button>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>
  </div>
  <div class="right-column">
    <div style="display: flex; flex-direction: column; margin: 20px; z-index: 1; width: 100%;">
      <div *ngIf="userAlert" class="alert">
        <div>{{userAlert}}</div>
        <button mat-button (click)="userAlert = null">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
      <mat-toolbar color="primary" class="toolbar-over-card" style="place-content: center space-between; align-items: center; flex-direction: row; box-sizing: border-box; display: flex; padding: 20px;">
        <div>
          {{ selectedJob ? selectedJob.title : 'Production Job' }}
        </div>
        <div style="display: flex;">
          <button mat-icon-button *ngIf="productionJobs.length > 0" [matMenuTriggerFor]="menuRight"><mat-icon>more_vert</mat-icon></button>
          <mat-menu #menuRight="matMenu">
            <div *ngIf="selectedJob">
              <button mat-menu-item [routerLink]="['/review/browse']" [queryParams]="{ ProductionJobId: selectedJob.productionJobId }">Go to Browse</button>
              <button id="exportWithheldLog.{{selectedJob?.productionJobId}}" [disabled]="selectedJob.status !== productionJobRunStatus.PostRun" mat-menu-item (click)="exportWithheldLog(selectedJob)">Export Privilege Log</button>
              <button id="downloadWithheld.{{selectedJob?.productionJobId}}" [disabled]="selectedJob.status !== productionJobRunStatus.PostRun" mat-menu-item (click)="downloadWithheld(selectedJob)">Download Withheld Files</button>
            </div>
            <button mat-menu-item id="setViewAllBatesRangesMode.{{selectedJob?.productionJobId}}" (click)="setViewAllBatesRangesMode()">View All Bates Ranges</button>
            <button mat-menu-item id="exportAllJobsToLog.{{selectedJob?.productionJobId}}" (click)="exportAllJobsToLog()">Export All Production Jobs</button>
            <div *ngIf="selectedJob && userConfigService.inRoles(Role.Operations) && selectedJob.status === productionJobRunStatus.PostRun">
              <button mat-menu-item id="operationsDownload.{{selectedJob?.productionJobId}}" (click)="operationsDownload()">DOWNLOAD TO FILE SERVER</button>
              <button mat-menu-item id="operationsConvertToTiff.{{selectedJob?.productionJobId}}" [disabled]="isProcessing && selectedJob.isCreateTiff === true" (click)="operationsConvertToTiff()">CONVERT TO TIFF</button>
            </div>
          </mat-menu>
        </div>
      </mat-toolbar>
      <mat-card appearance="outlined" class="card-under-toolbar" style="overflow: auto; display: flex; height: 100%;">
        <div *ngIf="productionJobs.length === 0">
          Please create a job
        </div>
        <div *ngIf="productionJobs.length > 0 && !selectedJob && !showBatesRangeView && !showCreateProductionView && !validateProduction">
          Please select a job
        </div>
        <div *ngIf="selectedJob && !showBatesRangeView && !showCreateProductionView && !validateProduction" style="height: 100%; width: 100%; display: flex;">
          <mat-card-content class="job-content">
            <lex-production-job-details [productionJob]="selectedJob" (formStatus)="formStatusUpdate($event)" style="height: 100%; width: 100%"></lex-production-job-details>
          </mat-card-content>
        </div>
        <div *ngIf="showCreateProductionView" style="height: 100%; width: 100%; display: flex;">
          <lex-create-production-job [productionJobs]="productionJobs" (createProductionEvent)="createProductionEvent($event)" style="width: 100%"></lex-create-production-job>
        </div>
        <div *ngIf="showBatesRangeView" style="height: 100%; width: 100%; display: flex;">
          <lex-bates-range-select [productionJobs]="productionJobs" (selectedRangeEvent)="selectedRangeEvent($event)" style="width: 100%"></lex-bates-range-select>
        </div>
        <div *ngIf="validateProduction" style="height: 100%; width: 100%; display: flex;">
          <lex-production-validation [productionJob]="selectedJob" (validationCompleteEvent)="completeValidation($event)" style="width: 100%"></lex-production-validation>
        </div>
      </mat-card>
    </div>
  </div>
</div>
